// extracted by mini-css-extract-plugin
export default {"line":"SolidLine_line__nWs77"};